/**
 * Blessy PDP Hero - Shopify Cart API Integration
 * Handles: flavor selection, qty steps, order summary, sticky bar, carousel, FAQ, confetti
 * Reads configuration from window.blessyConfig (injected by Liquid)
 *
 * ┌──────────────────────────────────────────────────────────────────┐
 * │  ALTERAÇÃO CartOps (jun/2026)                                   │
 * │  - goToCheckout() substituído por goToCheckoutCartOps()          │
 * │  - Sticky bar agora chama a mesma função                        │
 * │  - Adicionados: CARTOPS_VARIANTS, tierByQuantity,               │
 * │    readTrackingAttributes(), CSS spinner                        │
 * │  - Nenhum cupom/preço/discount é enviado pelo client            │
 * └──────────────────────────────────────────────────────────────────┘
 */
(function() {
  'use strict';

  // Prevent Sense theme cart drawer/notification from opening on our cart API calls
  var _cartNotifEl = document.querySelector('cart-notification');
  var _cartDrawerEl = document.querySelector('cart-drawer');
  var _origNotifRender = _cartNotifEl && _cartNotifEl.renderContents;
  var _origDrawerRender = _cartDrawerEl && _cartDrawerEl.renderContents;
  var _origNotifOpen = _cartNotifEl && _cartNotifEl.open;
  var _origDrawerOpen = _cartDrawerEl && _cartDrawerEl.open;

  function suppressDrawer() {
    if (_cartNotifEl) {
      _cartNotifEl.renderContents = function() {};
      _cartNotifEl.open = function() {};
    }
    if (_cartDrawerEl) {
      _cartDrawerEl.renderContents = function() {};
      _cartDrawerEl.open = function() {};
    }
  }

  function restoreDrawer() {
    if (_cartNotifEl && _origNotifRender) {
      _cartNotifEl.renderContents = _origNotifRender;
      _cartNotifEl.open = _origNotifOpen;
    }
    if (_cartDrawerEl && _origDrawerRender) {
      _cartDrawerEl.renderContents = _origDrawerRender;
      _cartDrawerEl.open = _origDrawerOpen;
    }
  }

  var config = window.blessyConfig || {};
  var FULL_PRICE = (config.pricePerUnit || 18990) / 100;
  var DISCOUNT_2 = config.discount2 || 14;
  var DISCOUNT_3 = config.discount3 || 25;
  var CTA_TEXT = config.ctaText || 'FINALIZAR COMPRA';
  var CTA_EMPTY_TEXT = config.ctaEmptyText || 'ESCOLHA ACIMA OS SABORES';

  var PRICES = {
    1: { perUnit: FULL_PRICE },
    2: { perUnit: Math.round(FULL_PRICE * (1 - DISCOUNT_2 / 100) * 100) / 100 },
    3: { perUnit: Math.round(FULL_PRICE * (1 - DISCOUNT_3 / 100) * 100) / 100 }
  };

  var selectedQty = 1;
  var cart = {};
  var lastTotal = 0;
  var isCartBusy = false;

  // ┌──────────────────────────────────────────────────────────────┐
  // │  NOVO — CartOps: mapeamento de sabores → variantId + sku    │
  // │  As chaves são os NOMES DE EXIBIÇÃO usados em data-flavor   │
  // └──────────────────────────────────────────────────────────────┘
  var CARTOPS_VARIANTS = {
    'Abacaxi c/ Hortel\u00e3': {
      variantId: 'gid://shopify/ProductVariant/52451457040747',
      sku: 'BLE-GRE-01-ABA'
    },
    'Lim\u00e3o': {
      variantId: 'gid://shopify/ProductVariant/52451469459819',
      sku: 'BLE-GRE-01-LIM'
    },
    'Melancia': {
      variantId: 'gid://shopify/ProductVariant/52451450421611',
      sku: 'BLE-GRE-01-MEL'
    },
    'Manga': {
      variantId: 'gid://shopify/ProductVariant/52450411151723',
      sku: 'BLE-GRE-01-MAN'
    },
    'Maracuj\u00e1': {
      variantId: 'gid://shopify/ProductVariant/53400375394667',
      sku: 'BLE-GRE-01-MAR'
    }
  };

  var tierByQuantity = {
    1: 'offer-1pote',
    2: 'offer-2potes',
    3: 'offer-3potes'
  };

  // DOM references
  var qtySteps = document.querySelectorAll('.qty-step');
  var flavorCards = document.querySelectorAll('.flavor-card');
  var orderPrice = document.getElementById('orderPrice');
  var orderOriginal = document.getElementById('orderOriginal');
  var orderPerUnit = document.getElementById('orderPerUnit');
  var orderThumbs = document.getElementById('orderThumbs');
  var discountTag = document.getElementById('discountTag');
  var discountTagText = document.getElementById('discountTagText');
  var ctaBtn = document.querySelector('.cta-btn');

  // Product data from blessyConfig
  var PRODUCTS = config.products || {};

  // Build ASSETS map from config products (image URLs)
  var ASSETS = {};
  Object.keys(PRODUCTS).forEach(function(name) {
    if (PRODUCTS[name].image) {
      ASSETS[name] = PRODUCTS[name].image;
    }
  });

  var FLAVOR_COLORS = {
    'Abacaxi c/ Hortel\u00e3': '#7ac943',
    'Melancia': '#e84c6a',
    'Lim\u00e3o': '#f5d020',
    'Manga': '#f7941d',
    'Maracuj\u00e1': '#f5a623'
  };

  var FLAVOR_EMOJIS = {
    'Abacaxi c/ Hortel\u00e3': '\ud83c\udf4d',
    'Melancia': '\ud83c\udf49',
    'Lim\u00e3o': '\ud83c\udf4b',
    'Manga': '\ud83e\udd6d',
    'Maracuj\u00e1': '\ud83c\udf4a'
  };

  // Populate qty step prices from config
  var qtyPriceEls = document.querySelectorAll('.qty-step-price[data-qty]');
  qtyPriceEls.forEach(function(el) {
    var q = parseInt(el.getAttribute('data-qty'), 10);
    if (PRICES[q]) {
      el.textContent = formatBRL(PRICES[q].perUnit) + '/pote';
    }
  });

  // ─── LOCAL CART (nenhuma chamada à Shopify até o checkout) ───

  function cartAdd(flavorName) {
    var product = PRODUCTS[flavorName];
    if (!product) return;

    cart[flavorName] = (cart[flavorName] || 0) + 1;
    showToast(flavorName);
    updateUI();
    updateHeaderBadge();
  }

  function cartUpdate(flavorName, newQty) {
    var product = PRODUCTS[flavorName];
    if (!product) return;

    if (newQty <= 0) {
      delete cart[flavorName];
    } else {
      cart[flavorName] = newQty;
    }
    updateUI();
    updateHeaderBadge();
  }

  function updateHeaderBadge() {
    var items = totalItems();
    var badge = document.getElementById('blessyCartCount');
    if (badge) {
      if (items > 0) {
        badge.textContent = items;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    }
  }

  function refreshThemeCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cartData) {
        var bubble = document.querySelector('.cart-count-bubble span, [data-cart-count], .cart-icon-bubble span');
        if (bubble) {
          bubble.textContent = cartData.item_count;
          var bubbleParent = bubble.closest('.cart-count-bubble, .cart-icon-bubble');
          if (bubbleParent) {
            if (cartData.item_count > 0) {
              bubbleParent.removeAttribute('hidden');
              bubbleParent.style.display = '';
            } else {
              bubbleParent.setAttribute('hidden', '');
            }
          }
        }

        var blessyBadge = document.getElementById('blessyCartCount');
        if (blessyBadge) {
          if (cartData.item_count > 0) {
            blessyBadge.textContent = cartData.item_count;
            blessyBadge.style.display = 'flex';
          } else {
            blessyBadge.style.display = 'none';
          }
        }
      })
      .catch(function() {});
  }

  // ┌──────────────────────────────────────────────────────────────┐
  // │  NOVO — CartOps: monta o payload e chama o checkout         │
  // │  Substitui a antiga goToCheckout() que usava /cart/add.js   │
  // └──────────────────────────────────────────────────────────────┘

  function buildCheckoutSelection() {
    var items = totalItems();
    var tier = tierByQuantity[items];
    if (!tier) throw new Error('Selecione 1, 2 ou 3 potes.');

    var lineItems = [];
    Object.keys(cart).forEach(function(name) {
      if (cart[name] <= 0) return;
      var variant = CARTOPS_VARIANTS[name];
      if (!variant) throw new Error('Sabor n\u00e3o reconhecido: ' + name);
      lineItems.push({
        variantId: variant.variantId,
        sku: variant.sku,
        quantity: cart[name]
      });
    });

    if (lineItems.length === 0) throw new Error('Nenhum sabor selecionado.');

    // Payload mínimo e seguro — sem cupom, sem preço, sem discount
    return { tier: tier, items: lineItems };
  }

  // ┌──────────────────────────────────────────────────────────────┐
  // │  TRACKING — lê UTMs do localStorage (salvas pelo script     │
  // │  global no theme.liquid) + gclid/fbclid/ttclid da URL.      │
  // │  Nenhuma escrita aqui — o theme.liquid já cuida disso.       │
  // └──────────────────────────────────────────────────────────────┘

  // UTMs: já persistidas no localStorage pelo theme.liquid
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];

  // Click IDs: não são salvos pelo theme.liquid, então lemos da URL
  var CLICK_ID_KEYS = ['gclid', 'fbclid', 'ttclid'];

  function readTrackingAttributes() {
    var result = {};

    // 1) UTMs do localStorage (persistidas pelo theme.liquid em todas as páginas)
    try {
      UTM_KEYS.forEach(function(key) {
        var val = localStorage.getItem(key);
        if (val) result[key] = val;
      });
    } catch(e) {}

    // 2) Click IDs da URL (gclid, fbclid, ttclid)
    var params = new URLSearchParams(window.location.search);
    CLICK_ID_KEYS.forEach(function(key) {
      var val = params.get(key);
      if (val) result[key] = val;
    });

    return result;
  }

  /**
   * Coloca um botão em estado de loading (spinner) e impede cliques.
   * Aceita o botão principal (.cta-btn) ou o da sticky bar (#stickyBtn).
   */
  function setBtnLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.classList.add('is-loading');
      btn.disabled = true;
    } else {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  }

  var isCheckoutBusy = false;

  function goToCheckout() {
    if (totalItems() === 0) return;
    if (isCheckoutBusy) return; // bloqueia clique duplo
    isCheckoutBusy = true;

    var stickyBtn = document.getElementById('stickyBtn');

    // Ativa spinner nos dois botões
    setBtnLoading(ctaBtn, true);
    setBtnLoading(stickyBtn, true);

    // Verifica se o CartOps client carregou
    if (!window.CartOpsPdp || typeof window.CartOpsPdp.checkout !== 'function') {
      showCheckoutError('Erro ao carregar checkout. Atualize a p\u00e1gina.');
      return;
    }

    window.CartOpsPdp.checkout({
      endpoint: 'https://api.useblessy.com.br/create-cart',
      offer: 'pdp-atual',
      surface: 'official_pdp',
      getSelection: buildCheckoutSelection,
      attributes: readTrackingAttributes()
    })
    .then(function() {
      // Sucesso: CartOps redireciona automaticamente.
      // Botões ficam em loading até o redirect acontecer.
    })
    .catch(function(err) {
      console.error('[CartOps PDP]', err);
      showCheckoutError(err && err.message);
    });
  }

  function showCheckoutError(message) {
    var stickyBtn = document.getElementById('stickyBtn');
    setBtnLoading(ctaBtn, false);
    setBtnLoading(stickyBtn, false);
    isCheckoutBusy = false;

    // Restaura texto dos botões
    var items = totalItems();
    if (items > 0) {
      var disc = getDiscount(items);
      var finalTotal = items * disc.perUnit;
      var parcela = formatBRL(finalTotal / 3);
      var txt = CTA_TEXT + ' \u2014 3X DE ' + parcela;
      ctaBtn.textContent = txt;
      if (stickyBtn) stickyBtn.textContent = txt;
    }

    // Mostra erro abaixo do CTA
    var box = document.querySelector('[data-cartops-error]');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-cartops-error', '');
      box.style.cssText = 'text-align:center;padding:8px 22px;color:#c0392b;font-size:14px;font-family:Poppins,sans-serif';
      var ctaSection = document.querySelector('.cta-section');
      if (ctaSection) ctaSection.insertAdjacentElement('afterend', box);
    }
    box.textContent = message || 'N\u00e3o foi poss\u00edvel iniciar o checkout. Tente novamente.';

    // Esconde o erro após 6s
    setTimeout(function() { if (box) box.textContent = ''; }, 6000);
  }

  // ─── TOAST ───

  function showToast(name) {
    var existing = document.querySelector('.flavor-toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'flavor-toast';
    var emoji = FLAVOR_EMOJIS[name] || '\u2728';
    var color = FLAVOR_COLORS[name] || '#2E6858';
    toast.style.background = color;
    toast.textContent = emoji + ' + ' + name + ' ' + emoji;
    document.body.appendChild(toast);
    setTimeout(function() { toast.remove(); }, 2500);
  }

  // ─── CONFETTI ───

  function confetti() {
    var colors = ['#bdf07d','#2E6858','#d4f5a0','#f59e0b','#1e4431','#fee2e2','#dc2626','#fff'];
    var count = 80;
    var container = document.createElement('div');
    container.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9999;overflow:hidden';
    document.body.appendChild(container);

    for (var i = 0; i < count; i++) {
      var p = document.createElement('div');
      var size = Math.random() * 8 + 4;
      var angle = Math.random() * Math.PI * 2;
      var velocity = Math.random() * 300 + 150;
      var endX = Math.cos(angle) * velocity;
      var endY = Math.sin(angle) * velocity;
      var spin = (Math.random() - 0.5) * 1080;
      var dur = Math.random() * 1 + 1.2;
      var delay = Math.random() * 0.15;
      var shape = Math.random() > 0.5 ? '50%' : (Math.random() > 0.5 ? '2px' : '0');
      var color = colors[Math.floor(Math.random() * colors.length)];

      p.style.cssText = 'position:absolute;top:50%;left:50%;width:' + size + 'px;height:' + (size * (Math.random() * 0.6 + 0.7)) + 'px;background:' + color + ';border-radius:' + shape + ';opacity:1;--ex:' + endX + 'px;--ey:' + endY + 'px;--spin:' + spin + 'deg;animation:confetti-burst ' + dur + 's cubic-bezier(.2,.8,.4,1) ' + delay + 's forwards';
      container.appendChild(p);
    }

    setTimeout(function() { container.remove(); }, 2500);
  }

  var confettiStyle = document.createElement('style');
  confettiStyle.textContent = '@keyframes confetti-burst{0%{transform:translate(0,0) rotate(0deg) scale(1);opacity:1}70%{opacity:1}100%{transform:translate(var(--ex),var(--ey)) rotate(var(--spin)) scale(0.3);opacity:0}}';
  document.head.appendChild(confettiStyle);

  // ┌──────────────────────────────────────────────────────────────┐
  // │  NOVO — CSS do spinner (botão em loading)                   │
  // └──────────────────────────────────────────────────────────────┘
  var spinnerStyle = document.createElement('style');
  spinnerStyle.textContent =
    '.cta-btn.is-loading,.sticky-bar__btn.is-loading{position:relative;color:transparent!important;pointer-events:none}' +
    '.cta-btn.is-loading>*,.sticky-bar__btn.is-loading>*{visibility:hidden}' +
    '.cta-btn.is-loading::after,.sticky-bar__btn.is-loading::after{content:"";width:22px;height:22px;' +
    'border:2px solid rgba(255,255,255,.45);border-top-color:#fff;border-radius:999px;' +
    'position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);' +
    'animation:cartops-spin .7s linear infinite}' +
    '@keyframes cartops-spin{to{transform:translate(-50%,-50%) rotate(360deg)}}';
  document.head.appendChild(spinnerStyle);

  // ─── HELPERS ───

  function formatBRL(v) {
    return 'R$ ' + v.toFixed(2).replace('.', ',');
  }

  function totalItems() {
    return Object.values(cart).reduce(function(s, q) { return s + q; }, 0);
  }

  function getDiscount(items) {
    if (items >= 3) return { pct: DISCOUNT_3, perUnit: PRICES[3].perUnit };
    if (items >= 2) return { pct: DISCOUNT_2, perUnit: PRICES[2].perUnit };
    return { pct: 0, perUnit: FULL_PRICE };
  }

  // ─── BUILD FLAVOR WIDGET ───

  function buildWidget(card, name) {
    var actionArea = card.querySelector('.flavor-actions');
    var qty = cart[name] || 0;

    if (qty === 0) {
      actionArea.innerHTML = '<div class="flavor-actions"><button class="flavor-btn">Adicionar +</button></div>';
      card.classList.remove('selected');
      actionArea.querySelector('.flavor-btn').addEventListener('click', function() {
        cartAdd(name);
      });
    } else {
      card.classList.add('selected');
      actionArea.innerHTML =
        '<div class="flavor-qty-widget">' +
          '<button class="flavor-qty-btn minus" aria-label="Diminuir">' +
            '<svg width="12" height="2" viewBox="0 0 12 2" fill="none"><path d="M0 1H12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<span class="flavor-qty-value">' + qty + '</span>' +
          '<button class="flavor-qty-btn plus" aria-label="Aumentar">' +
            '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M6 0V12M0 6H12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>';

      actionArea.querySelector('.minus').addEventListener('click', function() {
        var newQty = (cart[name] || 1) - 1;
        cartUpdate(name, newQty);
      });
      actionArea.querySelector('.plus').addEventListener('click', function() {
        var newQty = (cart[name] || 0) + 1;
        cartUpdate(name, newQty);
      });
    }
  }

  // ─── UPDATE UI ───

  function updateUI() {
    var items = totalItems();
    var disc = getDiscount(items);
    var originalTotal = items * FULL_PRICE;
    var finalTotal = items * disc.perUnit;

    if ((lastTotal < 2 && items >= 2) || (lastTotal < 3 && items >= 3)) {
      confetti();
    }
    lastTotal = items;

    var autoStep = items >= 3 ? 2 : items >= 2 ? 1 : items >= 1 ? 0 : -1;
    qtySteps.forEach(function(s, i) {
      var isReached = autoStep >= 0 && i < autoStep;
      var isActive = autoStep >= 0 && i === autoStep;
      s.classList.toggle('active', isActive);
      s.classList.toggle('reached', isReached);
      s.classList.toggle('next-step', items > 0 && i === autoStep + 1);
      var badge = s.querySelector('.qty-step-badge');
      if (badge && badge.dataset.locked) {
        badge.textContent = (isReached || isActive) ? badge.dataset.unlocked : badge.dataset.locked;
      }
    });
    if (items === 0) {
      qtySteps[0].classList.add('next-step');
    }
    selectedQty = autoStep + 1;

    orderPerUnit.textContent = formatBRL(disc.perUnit) + '/pote';

    if (items === 0) {
      orderOriginal.textContent = '';
      orderPrice.textContent = '';
      orderThumbs.innerHTML = '';
    } else {
      if (disc.pct > 0) {
        orderOriginal.textContent = formatBRL(originalTotal);
      } else {
        orderOriginal.textContent = '';
      }
      orderPrice.textContent = formatBRL(finalTotal);

      var thumbsHtml = '';
      Object.keys(cart).forEach(function(name) {
        if (ASSETS[name]) {
          thumbsHtml += '<img class="order-thumb" src="' + ASSETS[name] + '" alt="">';
        }
      });
      orderThumbs.innerHTML = thumbsHtml;
    }

    if (disc.pct > 0 && items > 0) {
      discountTag.classList.add('visible');
      discountTagText.textContent = 'VOC\u00ca GANHOU ' + disc.pct + '% OFF';
    } else {
      discountTag.classList.remove('visible');
    }

    if (items === 0) {
      ctaBtn.textContent = CTA_EMPTY_TEXT;
      ctaBtn.classList.add('disabled');
    } else {
      var parcela = formatBRL(finalTotal / 3);
      ctaBtn.textContent = CTA_TEXT + ' \u2014 3X DE ' + parcela;
      ctaBtn.classList.remove('disabled');
    }

    window.dispatchEvent(new CustomEvent('cart-updated', { detail: {
      items: items, cart: cart, finalTotal: finalTotal, originalTotal: originalTotal,
      disc: disc, images: ASSETS, formatBRL: formatBRL,
      ctaText: CTA_TEXT, ctaEmptyText: CTA_EMPTY_TEXT
    }}));

    flavorCards.forEach(function(card) {
      var name = card.getAttribute('data-flavor') || card.querySelector('.flavor-name').textContent;
      buildWidget(card, name);
    });
  }

  // ─── QTY STEP CLICKS ───

  qtySteps.forEach(function(step, i) {
    step.addEventListener('click', function() {
      var targetQty = i + 1;
      var currentItems = totalItems();

      if (targetQty <= currentItems) return;

      var toAdd = targetQty - currentItems;

      if (isCartBusy) return;

      if (currentItems === 0) {
        var defaultFlavors = Object.keys(PRODUCTS);
        for (var d = 0; d < toAdd && d < defaultFlavors.length; d++) {
          var fname = defaultFlavors[d];
          cart[fname] = (cart[fname] || 0) + 1;
          showToast(fname);
        }
        updateUI();
        updateHeaderBadge();
      } else {
        var firstFlavor = Object.keys(cart)[0];
        cartUpdate(firstFlavor, (cart[firstFlavor] || 0) + toAdd);
      }
    });
  });

  // ─── CTA CLICK ───

  ctaBtn.addEventListener('click', function() {
    if (totalItems() === 0) {
      var first = flavorCards[0];
      first.classList.remove('pulse');
      void first.offsetWidth;
      first.classList.add('pulse');
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function() { first.classList.remove('pulse'); }, 700);
    } else {
      goToCheckout();  // ← agora chama CartOps
    }
  });

  // Init
  updateUI();

})();

// ─── IMAGE CAROUSEL ───
(function() {
  var track = document.getElementById('carouselTrack');
  if (!track) return;

  var dotsWrap = document.getElementById('carouselDots');
  var leftBtn = document.getElementById('carouselLeft');
  var rightBtn = document.getElementById('carouselRight');

  var mobileImages = Array.prototype.slice.call(track.querySelectorAll('.hero-img-mobile'));
  var desktopImages = Array.prototype.slice.call(document.querySelectorAll('.hero-image-section .hero-img-desktop'));

  var total = Math.max(mobileImages.length, desktopImages.length, 1);
  var current = 0;

  if (dotsWrap) {
    dotsWrap.innerHTML = '';
    for (var i = 0; i < total; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Ir para slide ' + (i + 1));
      (function(index) {
        dot.addEventListener('click', function() {
          goTo(index);
        });
      })(i);
      dotsWrap.appendChild(dot);
    }
  }

  var dots = dotsWrap ? dotsWrap.querySelectorAll('.dot') : [];

  function syncDesktop(index) {
    if (!desktopImages.length) return;
    desktopImages.forEach(function(img, idx) {
      img.classList.toggle('is-active', idx === index);
    });
  }

  function syncMobile(index) {
    if (!mobileImages.length) return;
    track.style.transform = 'translateX(-' + (index * 100) + '%)';
  }

  function syncDots(index) {
    if (!dots.length) return;
    dots.forEach(function(dot, idx) {
      dot.classList.toggle('active', idx === index);
    });
  }

  function goTo(i) {
    current = Math.max(0, Math.min(i, total - 1));
    syncMobile(current);
    syncDesktop(current);
    syncDots(current);
  }

  if (leftBtn) {
    leftBtn.addEventListener('click', function() {
      goTo(current - 1);
    });
  }

  if (rightBtn) {
    rightBtn.addEventListener('click', function() {
      goTo(current + 1);
    });
  }

  var startX = 0;
  track.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
  }, { passive: true });

  track.addEventListener('touchend', function(e) {
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      goTo(current + (diff > 0 ? 1 : -1));
    }
  });

  goTo(0);
})();

// ─── FAQ ACCORDION ───
(function() {
  var items = document.querySelectorAll('.faq-item');
  items.forEach(function(item) {
    item.querySelector('.faq-question').addEventListener('click', function() {
      var wasOpen = item.classList.contains('open');
      items.forEach(function(i) { i.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
    });
  });
})();

// ─── STICKY BOTTOM BAR ───
(function() {
  var stickyBar = document.getElementById('stickyBar');
  if (!stickyBar) return;

  var stickyThumbs = document.getElementById('stickyThumbs');
  var stickyText = document.getElementById('stickyText');
  var stickyPrice = document.getElementById('stickyPrice');
  var stickyBtn = document.getElementById('stickyBtn');
  var flavorSelector = document.querySelector('.flavor-selector');
  var isVisible = false;

  var ctaSection = document.querySelector('.cta-section');

  function checkScroll() {
    if (!ctaSection) return;
    var rect = ctaSection.getBoundingClientRect();
    var shouldShow = rect.bottom < 0;

    if (shouldShow && !isVisible) {
      stickyBar.classList.add('visible');
      isVisible = true;
    } else if (!shouldShow && isVisible) {
      stickyBar.classList.remove('visible');
      isVisible = false;
    }
  }

  window.addEventListener('scroll', checkScroll, { passive: true });

  window.addEventListener('cart-updated', function(e) {
    var detail = e.detail;
    var items = detail.items;
    var cartData = detail.cart;
    var finalTotal = detail.finalTotal;
    var originalTotal = detail.originalTotal;
    var disc = detail.disc;
    var ctaText = detail.ctaText || 'FINALIZAR COMPRA';
    var ctaEmptyText = detail.ctaEmptyText || 'ESCOLHA ACIMA OS SABORES';

    if (items === 0) {
      stickyThumbs.innerHTML = '';
      stickyText.textContent = 'Nenhum item adicionado';
      stickyPrice.innerHTML = '';
      stickyBtn.textContent = ctaEmptyText;
      stickyBtn.classList.add('empty');
    } else {
      var IMGS = detail.images;
      var html = '';
      Object.keys(cartData).forEach(function(name) {
        if (IMGS[name]) html += '<img class="sticky-bar__thumb" src="' + IMGS[name] + '" alt="">';
      });
      stickyThumbs.innerHTML = html;

      stickyText.textContent = items + (items === 1 ? ' pote' : ' potes');

      var priceHtml = '';
      if (disc.pct > 0) {
        priceHtml += '<span class="sticky-bar__price-original">' + detail.formatBRL(originalTotal) + '</span>';
      }
      priceHtml += detail.formatBRL(finalTotal);
      stickyPrice.innerHTML = priceHtml;

      var parcela = detail.formatBRL(finalTotal / 3);
      stickyBtn.textContent = ctaText + ' \u2014 3X DE ' + parcela;
      stickyBtn.classList.remove('empty');
    }
  });

  // ┌──────────────────────────────────────────────────────────────┐
  // │  ALTERADO — sticky bar agora chama goToCheckout (CartOps)   │
  // │  Antes fazia: window.location.href = '/checkout'            │
  // └──────────────────────────────────────────────────────────────┘
  stickyBtn.addEventListener('click', function() {
    if (stickyBtn.classList.contains('empty')) {
      if (flavorSelector) {
        flavorSelector.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function() {
          var first = flavorSelector.querySelector('.flavor-card');
          if (first) {
            first.classList.remove('pulse');
            void first.offsetWidth;
            first.classList.add('pulse');
            setTimeout(function() { first.classList.remove('pulse'); }, 700);
          }
        }, 500);
      }
    } else {
      // Dispara evento para que o IIFE principal execute goToCheckout
      window.dispatchEvent(new CustomEvent('blessy-checkout'));
    }
  });
})();

// Bridge: permite que a sticky bar (IIFE separado) acione o checkout do IIFE principal
window.addEventListener('blessy-checkout', function() {
  var ctaBtn = document.querySelector('.cta-btn');
  if (ctaBtn) ctaBtn.click();
});